<!--管理界面-->
<template>
  <el-tooltip class="box-item" effect="dark" :content="contentText()" placement="bottom">
    <div class="no-trace " @click="jumpManagement()">
      <img src="~assets/images/icons/admin.svg" alt="">
    </div>
  </el-tooltip>
</template>
<script>
import { useRouter } from "vue-router";

export default {
  name: 'Management',
  components: {},
  setup () {
    const router = useRouter();
    const contentText = () => {
      let text = '管理界面'
      return text
    };

    const jumpManagement = () => {
      router.push('/Manage/UserManagement');
    };

    return {
      contentText,
      jumpManagement
    }
  },
};
</script>